
import { Facebook, Instagram, Youtube, Linkedin } from 'lucide-react';
import { FaXTwitter } from 'react-icons/fa6';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Dealer } from '@/types/dealer';

type DealerSocialLinksProps = Pick<Dealer, 'facebook' | 'instagram' | 'twitter' | 'youtube' | 'linkedin'>;

const socialConfig = [
  { key: 'facebook', Icon: Facebook, label: 'Facebook', baseUrl: 'https://www.facebook.com/' },
  { key: 'instagram', Icon: Instagram, label: 'Instagram', baseUrl: 'https://www.instagram.com/' },
  { key: 'twitter', Icon: FaXTwitter, label: 'Twitter / X', baseUrl: 'https://www.twitter.com/' },
  { key: 'youtube', Icon: Youtube, label: 'YouTube', baseUrl: 'https://www.youtube.com/' },
  { key: 'linkedin', Icon: Linkedin, label: 'LinkedIn', baseUrl: 'https://www.linkedin.com/company/' },
] as const;

export function DealerSocialLinks(props: DealerSocialLinksProps) {
  const availableLinks = socialConfig.filter(({ key }) => props[key]);

  if (availableLinks.length === 0) {
    return null;
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Seguici sui Social</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex flex-wrap gap-4">
          {availableLinks.map(({ key, Icon, label, baseUrl }) => {
            const linkValue = props[key];
            if (!linkValue) return null;
            
            const href = linkValue.startsWith('http') ? linkValue : `${baseUrl}${linkValue}`;

            return (
              <a
                key={key}
                href={href}
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="text-muted-foreground hover:text-primary transition-colors"
                aria-label={`Profilo ${label}`}
              >
                <Icon className="h-6 w-6" />
              </a>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
}
